import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { CloudDownload, GetApp, Visibility } from '@material-ui/icons';
import Button from '@material-ui/core/Button';

const defaultToolbarStyles = {
  iconButton: {},
};

class TableToolbarExtra extends React.Component {
  handleWordDownload = () => {
    console.log('clicked on handleWordDownload!');
    this.props.onDownload();
  };
  handleWordPreview = () => {
    console.log('clicked on handleWordPreivew!');
    this.props.onPreview();
  };

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Tooltip title={'word backup'}>
          <Button
            variant="outlined"
            color="default"
            startIcon={<CloudDownload />}
            style={{ marginRight: 10 }}
            onClick={this.handleWordDownload}
          >
            워드 백업
          </Button>
        </Tooltip>
        <Tooltip title={'word preview'}>
          <Button variant="outlined" color="default" startIcon={<Visibility />} onClick={this.handleWordPreview}>
            워드 미리보기
          </Button>
        </Tooltip>
      </React.Fragment>
    );
  }
}

export default withStyles(defaultToolbarStyles, { name: 'TableToolbarExtra' })(TableToolbarExtra);
